module.exports = __webpack_public_path__ + "static/react-themes-stellar-d030197219b7fd585c001444b08b23db.jpg";